// extracted by mini-css-extract-plugin
export default {"certifiedWrapper":"certifiedWrapper___KYy0B","certified":"certified___dY0rN","uncertified":"uncertified___J3O9G"};